export default "__VITE_ASSET__48eb5a4b__"